import React from 'react';
import { Box } from '@mui/material';

const LogoHeader: React.FC = () => (
  <Box 
    component="span" 
    sx={{ 
      display: 'flex',
      alignItems: 'center',
      background: 'transparent' // Forza la trasparenza
    }}
  >
    <img 
      src="/logo.png" 
      alt="Logo" 
      style={{ 
        height: 60,
        display: 'block' // Evita spazi bianchi sotto l'immagine
      }} 
    />
  </Box>
);

export default LogoHeader;